const storeText={play_videos:'Play videos',pause_videos:'Pause videos',retry_play:'Try playing again',play_again:'Play again',sold_out:'Sold out',add:'Add to bag',adding:'Adding to your bag…',add_error:'This item could not be added. Check your selection and try again.',added:'Added to your bag.',update_uncertain:'We could not confirm the update. Open your bag to check before trying again.',bag_count:'Bag ({{ count }})',...JSON.parse(document.getElementById('acha-store-messages')?.textContent||'{}')};
let returnFocus;
function showDialog(id,trigger){
  const open=document.querySelector('dialog[open]');
  if(!open)returnFocus=trigger;
  if(open)open.close();
  document.getElementById(id).showModal();
  if(id==='menu'){
    document.documentElement.classList.add('navigation-open');
    trigger.setAttribute('aria-expanded','true');
  }
}
document.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{
  if(dialog.id==='menu'&&!dialog.open){
    document.documentElement.classList.remove('navigation-open');
    document.querySelector('[data-dialog="menu"]').setAttribute('aria-expanded','false');
  }
  if(!document.querySelector('dialog[open]'))returnFocus?.focus();
}));

const gallery=document.getElementById('community-rail');
if(gallery){
const previous=document.getElementById('gallery-prev');
const next=document.getElementById('gallery-next');
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
function updateArrows(){
  const position=gallery.scrollLeft;
  const end=gallery.scrollWidth-gallery.clientWidth;
  previous.disabled=position<=2;
  next.disabled=position>=end-2;
}
function moveGallery(direction){
  const step=gallery.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(gallery).columnGap);
  gallery.scrollBy({left:step*direction,behavior:reducedMotion.matches?'instant':'smooth'});
}
previous.addEventListener('click',()=>moveGallery(-1));next.addEventListener('click',()=>moveGallery(1));
gallery.addEventListener('scroll',updateArrows,{passive:true});
// The observer provides the first size after layout, without a synchronous startup measurement.
new ResizeObserver(updateArrows).observe(gallery);

const videos=[...gallery.querySelectorAll('video')];
const visibleVideos=new Set();
const videoToggle=document.getElementById('video-toggle');
let videosPaused=reducedMotion.matches;
function syncVideos(){
  videoToggle.textContent=videosPaused?storeText.play_videos:storeText.pause_videos;
  videoToggle.setAttribute('aria-pressed',String(videosPaused));
  videos.forEach(video=>{if(!videosPaused&&!document.hidden&&visibleVideos.has(video)){video.play().catch(()=>{});}else video.pause();});
}
const videoObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)visibleVideos.add(entry.target);else visibleVideos.delete(entry.target);});syncVideos();},{threshold:.55});
videos.forEach(video=>videoObserver.observe(video));
videoToggle.addEventListener('click',()=>{videosPaused=!videosPaused;syncVideos();});
document.addEventListener('visibilitychange',syncVideos);
reducedMotion.addEventListener('change',()=>{videosPaused=reducedMotion.matches;syncVideos();});syncVideos();


}
document.querySelectorAll('.ritual-player').forEach(player=>{
  const video=player.querySelector('video');
  const button=player.querySelector('[data-ritual-play]');
  const label=button.querySelector('span');
  button.hidden=false;
  button.addEventListener('click',async()=>{
    button.disabled=true;
    try{await video.play();}catch{label.textContent=storeText.retry_play;}
    finally{button.disabled=false;}
  });
  video.addEventListener('play',()=>{button.hidden=true;video.focus();});
  video.addEventListener('ended',()=>{label.textContent=storeText.play_again;button.hidden=false;});
});

const deferredPosterVideos=[...document.querySelectorAll('video[data-deferred-poster]')];
let posterObserver;
function loadProductPoster(video){
  if(!video.dataset.deferredPoster)return;
  video.poster=video.dataset.deferredPoster;
  delete video.dataset.deferredPoster;
  posterObserver?.unobserve(video);
}
if(deferredPosterVideos.length&&'IntersectionObserver'in window){
  posterObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)loadProductPoster(entry.target);}),{rootMargin:'200px 0px'});
  deferredPosterVideos.forEach(video=>posterObserver.observe(video));
}else deferredPosterVideos.forEach(loadProductPoster);
deferredPosterVideos.forEach(video=>video.addEventListener('play',()=>loadProductPoster(video),{once:true}));

document.addEventListener('click',event=>{
const trigger=event.target.closest('[data-dialog]');
if(trigger&&document.getElementById(trigger.dataset.dialog)){event.preventDefault();showDialog(trigger.dataset.dialog,trigger);}
const closer=event.target.closest('[data-close],[data-close-link]');if(closer)closer.closest('dialog').close();
const step=event.target.closest('[data-step]');if(step){const input=step.parentElement.querySelector('input');if(Number(step.dataset.step)>0)input.stepUp();else input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}
const photo=event.target.closest('[data-photo]');if(photo){const media=photo.closest('.pdp-media');const img=media.querySelector(':scope > img');img.src=photo.dataset.photo;img.removeAttribute('srcset');img.alt=photo.dataset.alt;media.querySelectorAll('[data-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===photo)));}
});
document.addEventListener('change',event=>{if(!event.target.matches('[data-variant]'))return;const selected=event.target.selectedOptions[0];const form=event.target.form;const button=form.querySelector('button[type=submit]');button.disabled=selected.dataset.available!=='true';form.querySelector('[data-add-label]').textContent=button.disabled?storeText.sold_out:storeText.add;const pricing=form.closest('[data-product-pricing]');const price=pricing?.querySelector('[data-product-price]');if(price)price.textContent=selected.dataset.price;const unitPrice=pricing?.querySelector('[data-product-unit-price]');if(unitPrice){const value=selected.dataset.unitPrice||'';unitPrice.querySelector('[data-unit-price-value]').textContent=value;unitPrice.hidden=!value;}});
document.querySelectorAll('.desktop-nav a,#menu nav a').forEach(link=>{if(new URL(link.href).pathname===location.pathname&&new URL(link.href).search===location.search)link.setAttribute('aria-current','page');});
document.addEventListener('submit',async event=>{
const form=event.target;if(!form.matches('[data-native-add]'))return;
event.preventDefault();if(form.dataset.pending)return;form.dataset.pending='true';const button=form.querySelector('button[type=submit]');const status=form.querySelector('[data-product-status]');button.disabled=true;status.textContent=storeText.adding;
const payload=new FormData(form);payload.append('sections','acha-store-cart-drawer');payload.append('sections_url',location.pathname);
const controls=[...form.querySelectorAll('input,select,[data-step]')].filter(control=>!control.disabled);controls.forEach(control=>control.disabled=true);
const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
try{const response=await fetch(document.body.dataset.cartAddUrl,{method:'POST',headers:{Accept:'application/json'},body:payload,signal:controller.signal});const result=await response.json();if(!response.ok){status.textContent=result.description||storeText.add_error;return;}
status.textContent=storeText.added;
const html=result.sections?.['acha-store-cart-drawer'];if(html){const parsed=new DOMParser().parseFromString(html,'text/html');const replacement=parsed.getElementById('shopping-bag');if(replacement){document.getElementById('shopping-bag').replaceWith(replacement);document.querySelectorAll('[data-bag-count]').forEach(label=>label.textContent=storeText.bag_count.replace('{{ count }}',replacement.dataset.itemCount).replace('__COUNT__',replacement.dataset.itemCount));showDialog('shopping-bag',button);replacement.addEventListener('close',()=>returnFocus?.focus());}}
}catch{status.textContent=storeText.update_uncertain;}finally{clearTimeout(timeout);delete form.dataset.pending;controls.forEach(control=>control.disabled=false);button.disabled=false;}
});
